import React from 'react';

import CircularIcon from '../CircularIcon/CircularIcon';
import LoaderFillIcon from '../Icons/LoaderFillIcon';
import { Robot2FillIcon } from '../Icons';

const SubmissionLoader = ({
    text = "We're building it!",
    bottomText = 'Loading awesomeness...',
}) => {
    return (
        <div className="py-[40px] l:py-[80px] flex flex-col items-center justify-center">
            <CircularIcon icon={Robot2FillIcon} color="purple" marginBottom={16} />
            <p className="font-heading-bold text-heading-bold-m text-black mb-1 text-center">
                {text}
            </p>
            <p className="font-body text-body-regular-m text-black mb-4 text-center">
                {bottomText}
            </p>
            <div className="animate-icon-spin">
                <LoaderFillIcon width={32} height={32} color="#754DCF" />
            </div>
        </div>
    );
};

export default SubmissionLoader;
